export const getGiftCardValidationNonce = (state: WtrState) =>
  state.order?.giftCardValidationNonce?.nonce;
